import { render, staticRenderFns } from "./counterTag.vue?vue&type=template&id=61ce0be9"
import script from "./counterTag.vue?vue&type=script&lang=js"
export * from "./counterTag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports